import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { personaEnums } from '../enums'
import { personaActions } from '../redux/actions'
import { selectPersona } from '../redux/selectors'
import { personaTypes } from '../types'
import personas from '../utils/static-data/personas'

function usePersona() {
  const dispatch = useDispatch()
  const persona: personaTypes.Persona = useSelector(selectPersona)

  const setPersona = useCallback((personaName: personaEnums.personas): void => {
    dispatch(personaActions.update(personas[personaName]))
  }, [dispatch])

  const resetPersona = useCallback((): void => {
    dispatch(personaActions.update(personas[personaEnums.personas.INITIAL]))
  }, [dispatch])

  return { persona, resetPersona, setPersona }
}

export default usePersona
